import { render, staticRenderFns } from "./SlotSwitch.vue?vue&type=template&id=190630d7&"
import script from "./SlotSwitch.vue?vue&type=script&lang=ts&"
export * from "./SlotSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports